var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-description"},[_c('p',{staticClass:"card-title"},[_vm._v("Признак партнера")]),_vm._l((_vm.attributesList),function(attribute){return _c('p',{key:attribute.name,staticClass:"card-title__small"},[_vm._v(_vm._s(attribute.name))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }